module.exports = __webpack_public_path__ + "media/theme/blog__border-5-dfbef639.png";